// Shared call-dock state that outlives one CallDock instance: what the dock
// is showing (so the shortcuts sheet can list the keys that work right now)
// and a wrap-up still waiting for its outcome (so a remounted shell brings
// the sheet back instead of dropping the disposition).

import { useSyncExternalStore } from "react";

let state = { mode: "idle", pendingWrap: null };
const listeners = new Set();

export const getDockState = () => state;

export const setDockState = (patch) => {
  const next = { ...state, ...patch };
  if (next.mode === state.mode && next.pendingWrap === state.pendingWrap) return;
  state = next;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/** Current dock state: { mode: "idle" | "ringing" | "dialling" | "live" | "wrap", pendingWrap }. */
export const useDockState = () => useSyncExternalStore(subscribe, getDockState, getDockState);

/** Live-bar keys, shown in the shortcuts sheet while a dock call is live. */
export const DOCK_LIVE_KEYS = [
  { key: "M", description: "Mute or unmute the call" },
  { key: "H", description: "Hold or resume the call" },
  { key: "T", description: "Transfer the call" },
  { key: "Shift E", description: "End the call" },
];

/** The Focus key, listed only when the Live view exists. */
export const DOCK_FOCUS_KEY = { key: "F", description: "Open the call in the Live view" };

/** Wrap-up sheet keys, shown while the sheet is open. */
export const DOCK_WRAP_KEYS = [
  { key: "1–6", description: "Pick the call outcome" },
  { key: "Enter", description: "Save the wrap-up (focus in the sheet)" },
  { key: "Escape", description: "Close the wrap-up" },
];
